import { render, staticRenderFns } from "./ResponsiveRowSwitch.vue?vue&type=template&id=2c229af8"
import script from "./ResponsiveRowSwitch.vue?vue&type=script&lang=ts"
export * from "./ResponsiveRowSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c229af8')) {
      api.createRecord('2c229af8', component.options)
    } else {
      api.reload('2c229af8', component.options)
    }
    module.hot.accept("./ResponsiveRowSwitch.vue?vue&type=template&id=2c229af8", function () {
      api.rerender('2c229af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/controltable/ResponsiveRowSwitch.vue"
export default component.exports